import { UrlSegment } from '@angular/router';

export const restoreSlashedUrlCode = (segments: UrlSegment[]) => {
    return new UrlSegment(segments.map(x => x.path).join(''), { });
};
